import { useIntl } from 'react-intl';
import { IconAlertTriangle, IconNote } from '@rossum/ui/icons/tabler';
import { Stack, SvgIcon, Tooltip } from '@rossum/ui/material';
import { GridRenderCellParams } from '@rossum/ui/x-data-grid-pro';
import { TransformedOperation } from '../helpers';

// The tooltip stays readable; the rest is only counted.
const MAX_SHOWN_VIOLATIONS = 10;

export const ErrorNote = ({
  value: error,
  row,
}: GridRenderCellParams<TransformedOperation, string>) => {
  const intl = useIntl();
  if (!error) return null;

  // A failed import into a dataset with declared columns says which rows
  // broke them.
  const violations = row.metadata.schema_violations ?? [];
  const hidden = violations.length - MAX_SHOWN_VIOLATIONS;

  return (
    <Tooltip
      title={
        <Stack direction="column" spacing={0.5} alignItems="center">
          <SvgIcon fontSize="medium" color="error">
            <IconAlertTriangle />
          </SvgIcon>
          <Stack spacing={0}>
            <div>{error}</div>
            {violations.slice(0, MAX_SHOWN_VIOLATIONS).map(violation => (
              <div
                key={`${violation.row}-${violation.field}-${violation.code}`}
              >
                {intl.formatMessage(
                  { id: 'features.datasets.logs.violation' },
                  {
                    row: violation.row,
                    field: violation.field,
                    message: violation.message,
                  }
                )}
              </div>
            ))}
            {hidden > 0 ? (
              <div>
                {intl.formatMessage(
                  { id: 'features.datasets.logs.violationsHidden' },
                  { count: hidden }
                )}
              </div>
            ) : null}
          </Stack>
        </Stack>
      }
      placement="top"
    >
      <SvgIcon fontSize="medium" color="action">
        <IconNote />
      </SvgIcon>
    </Tooltip>
  );
};
